import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-14-nishant-arya-guest.webp";
import ThumbImg from "../../assets/images/conversations/014.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: na2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .na2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .na2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .na2-hero { padding-top: 60px; padding-bottom: 60px; }
  .na2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .na2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .na2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .na2-hero__title.na2-visible { opacity: 1; transform: translateY(0); }
  .na2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .na2-hero__spotify.na2-visible { opacity: 1; transform: translateY(0); }
  .na2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .na2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .na2-hero__right.na2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .na2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .na2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .na2-yt-thumb:hover img { opacity: 0.85; }
  .na2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .na2-yt-thumb__play img { width: 40px; height: 44px; }
  .na2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .na2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .na2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .na2-body.na2-visible { opacity: 1; transform: translateY(0); }
  .na2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .na2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .na2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .na2-guest.na2-visible { opacity: 1; transform: translateY(0); }
  .na2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .na2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .na2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .na2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .na2-inner { padding-left: 32px; padding-right: 32px; }
    .na2-hero { padding-top: 32px; padding-bottom: 48px; }
    .na2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .na2-hero__title { font-size: 24px; }
    .na2-hero__left { gap: 16px; }
    .na2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .na2-guest__photo-bg { width: 260px; height: 300px; }
    .na2-guest__name { font-size: 24px; margin-top: 18px; }
    .na2-body__para { font-size: 14px; margin-bottom: 12px; }
    .na2-body { padding-bottom: 48px; }
    .na2-guest { padding-bottom: 48px; }
    .na2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .na2-inner { padding-left: 16px; padding-right: 16px; }
    .na2-hero { padding-top: 51px; padding-bottom: 30px; }
    .na2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .na2-hero__left { gap: 30px; }
    .na2-hero__title { font-size: 30px; }
    .na2-body__para { font-size: 16px; margin-bottom: 10px; }
    .na2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .na2-guest__photo-bg { width: 100%; height: 386px; }
    .na2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .na2-body { padding-bottom: 30px; }
    .na2-guest { padding-bottom: 30px; }
    .na2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("na2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "bnlF9J3lgHU";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="na2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 14 Nishant Arya JBM"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="na2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 14 Nishant Arya thumbnail" />
      <div className="na2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="na2-hero">
      <div className="na2-inner">
        <div className="na2-hero__grid">
          <div className="na2-hero__left">
            <h1 ref={titleRef} className="na2-hero__title">
              EP 14 | Buses of the future – changing how India gets to work | JBM
            </h1>
            <div ref={spotifyRef} className="na2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/3xRFmtEnEADGyhp8oqdv53?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 14 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="na2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="na2-body">
      <div className="na2-inner">
        <p className="na2-body__para">
          Today we focus on mass public transport, the electric bus sector and speak with Nishant Arya Vice Chairman &amp; MD, JBM Auto Ltd., the flagship company of the $2.2B Indian conglomerate JBM Group that recently under his stewardship enter the electric vehicle sector and is finding significant success. Nishant studied at Bradford University and then the London School of Economics in the United Kingdom and worked with multinational corporations in both Europe and Japan before returning to lead the JBM group's foray into the Electric Vehicle sector in India. Their investments now include not just manufacturing Electric buses, but also Lithium batteries, charging infrastructure, and ChargePoint operations. In effect, JBM will operate in all parts of the EV ecosystem in India. JBM has introduced the ECOLIFE Electric bus in both 9 and 12-meter length variants and these are already redefining the dynamics of public transports in many cities in India.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="na2-guest">
      <div className="na2-inner">
        <h2 className="na2-guest__title">Our Guest</h2>
        <div>
          <div className="na2-guest__photo-bg">
            <img src={GuestImg} alt="Nishant Arya" />
          </div>
          <p className="na2-guest__name">Nishant ARYA</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep14NishantArya() {
  return (
    <>
      <style>{CSS}</style>
      <div className="na2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}